module.exports = __webpack_public_path__ + "img/TUR.491abdd5.svg";